/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Faq_Free_QInputs */

const en_price_page_faq_free_q = /** @type {(inputs: Price_Page_Faq_Free_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does the app cost anything?`)
};

const pl_price_page_faq_free_q = /** @type {(inputs: Price_Page_Faq_Free_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czy aplikacja jest płatna?`)
};

/**
* | output |
* | --- |
* | "Does the app cost anything?" |
*
* @param {Price_Page_Faq_Free_QInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_faq_free_q = /** @type {((inputs?: Price_Page_Faq_Free_QInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Faq_Free_QInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_faq_free_q(inputs)
	return en_price_page_faq_free_q(inputs)
});